'use strict';

/**
 * @ngdoc config
 * @name gfcmsApp.exception.config
 * @description
 * # exception.config
 * Config in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .config(function($provide) {

    $provide.decorator('$exceptionHandler', extendExceptionHandler);

    /* @ngInject */
    function extendExceptionHandler(errorlogService) {
      return errorlogService;
    }
  });
